export function createCtaActivator(label, props) {
  const activator = document.createElement("sp-button");
  activator.label = label;

  Object.assign(activator, props ?? {});

  return activator;
}
